import React from 'react'
import { Button, Grid, Icon, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import styles from 'components/FileUploader/file-uploader.module.scss'
import StatusIcon from 'components/FileUploader/subcomponents/StatusIcon'
import formatBytes from 'utils/formatBytes'
import clsx from 'clsx'

const ReadyRow = ({ name, remove, total, disabled }) => {
  return (
    <Grid
      gap={16}
      wrap={false}
    >
      <StatusIcon status={'loaded'} />

      <Grid
        direction={'column'}
        gap={4}
        className={clsx(styles['col'], styles['col-2'])}
      >
        <Typography
          variant={'Body-15'}
          noMargin
          className={styles['row__file-name']}
        >
          {name}
        </Typography>
        <Typography
          variant={'Body-10'}
          color={'Label-Secondary'}
          noMargin
          className={styles['row__file-name']}
        >
          {formatBytes(total)}
        </Typography>
      </Grid>

      <Button
        variant={'ghost'}
        grey
        link
        startIcon={
          <Icon
            name={'trash'}
            color={'Interface-Eighth'}
          />
        }
        noLabel
        color={'Interface-Seventh'}
        size={'m'}
        onClick={remove}
        disabled={disabled}
      />
    </Grid>
  )
}

ReadyRow.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
  total: PropTypes.number,
  remove: PropTypes.func,
}

export default ReadyRow
